var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-empty"},[(_vm.icon)?_c('i',{staticClass:"fa-regular fa-2x",class:_vm.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.$slots.default)?_c('div',{staticClass:"section-empty__actions"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }